
  import ButtonComponent from "../common/ButtonComponent";

  export default {
    name: "BannerMainPage",
    components: { ButtonComponent }
  };
